import { Guid } from "guid-typescript";
import _ from "lodash";
import * as React from "react";
import { PropertyHelper } from "../../../../shared/utility/property-helper";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";

export interface IPropertyFormInputNumberPropertyState {
  value: string;
  currentValue: string;
}

export interface IPropertyFormInputNumberPropertyProps {
  value: string;
  onChange: (value: string) => void;
  changeType: "onBlur" | "onKeyPress";
  updateDebounce: number;
  minValue?: number;
  disabled?: boolean;
  /** `data-testid` of the number input, e.g. SymbolPicker's `property-input-<name>`. */
  testId?: string;
}

export class PropertyFormInputNumberProperty extends React.PureComponent<
  IPropertyFormInputNumberPropertyProps,
  IPropertyFormInputNumberPropertyState
> {
  private uniquePropertyInputId: Guid = Guid.create();

  private isFocused: boolean = false;

  constructor(props) {
    super(props);
  }

  public static defaultProps = {
    changeType: "onKeyPress"
  };

  componentDidMount(): void {
    let value = this.props.value;
    if (this.props.minValue && parseInt(this.props.value) < this.props.minValue) {
      value = this.props.minValue.toString();
    }
    this.setState({ currentValue: value });
    document.addEventListener("click", this.onClickOutside.bind(this));
  }

  componentDidUpdate = (prevProps: IPropertyFormInputNumberPropertyProps) => {
    if (prevProps === this.props) return;
    let value = this.props.value;
    if (this.props.minValue && parseInt(this.props.value) < this.props.minValue) {
      value = this.props.minValue.toString();
    }
    this.setState({ value: this.getTextValueForMetaData(value) });
  };

  componentWillUnmount(): void {
    document.removeEventListener("click", this.onClickOutside.bind(this));
  }

  getTextValueForMetaData = (value) => {
    if (value === null || value === undefined) return "";
    return PropertyHelper.getTextValueForMetaData(value.toString());
  };

  waitAndChange = _.debounce((value: string) => this.props.onChange(value), this.props.updateDebounce);

  handleInputNumberChange = (event: any) => {
    if (this.props.minValue && parseInt(event.target.value) < this.props.minValue) {
      event.target.value = this.props.minValue;
    }
    if (this.props.changeType === "onKeyPress") {
      let { value } = event.target;
      if (isNaN(value)) return;
      value = parseFloat(value).toString();
      this.waitAndChange(value);
    }

    if (this.props.changeType === "onBlur") {
      let { value } = event.target;
      if (isNaN(value)) return;
      value = parseFloat(value).toString();
      this.setState({ currentValue: value });
    }
  };

  handleBlur = (event: any) => {
    if (this.props.minValue && parseInt(event.target.value) < this.props.minValue) {
      event.target.value = this.props.minValue;
    }
    if (this.props.changeType === "onBlur") {
      const value = this.getTextValueForMetaData(event.target.value);
      if (value !== this.props.value) {
        this.props.onChange(value);
      }
    }
  };

  // A stored value below the minimum opens at the minimum instead.
  getInitialValue = (): string | number => {
    if (this.props.minValue && parseInt(this.props.value) < this.props.minValue) {
      return this.props.minValue;
    }
    return this.props.value;
  };

  handleFocus = (event: any) => {
    event.target.select();
    this.isFocused = true;
  };

  onFocusCapture = () => {
    this.isFocused = true;
  };

  onClickOutside = (e: MouseEvent) => {
    // const currentInputId = `property-number-input-${this.uniquePropertyInputId.toString()}`;
    // if (!(e.target instanceof HTMLElement)) return;
    // if (e.target.id === currentInputId) return;
    // if (this.isFocused) {
    //   this.handleBlur({
    //     target: {
    //       value: this.state.currentValue
    //     }
    //   });
    // }
  };

  render() {
    return (
      <>
        <div className="kuika_property-grid-column kuika-right-panel__col">
          <KuikaInput
            id={`property-number-input-${this.uniquePropertyInputId.toString()}`}
            type="number"
            // A property's number is stored as the text typed; the kit would otherwise round it to
            // a whole number and hand back a number where the handlers below expect a string.
            keepTypedValue
            className="form-control-sm form-control kuika_input_property kuika_property-grid-input"
            defaultValue={this.getInitialValue()}
            onBlur={this.handleBlur}
            onChange={this.handleInputNumberChange}
            // autoFocus
            onFocus={this.handleFocus}
            onFocusCapture={this.onFocusCapture}
            min={this.props.minValue}
            disabled={this.props.disabled}
            data-testid={this.props.testId}
          />
        </div>
      </>
    );
  }
}
